import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useTranslation } from 'react-i18next';

import Section from '../shared/Section';
import './avignon.css';
import { ArrowUpRight } from 'react-feather';
import { Fichier1, Fichier2, Fichier3, Fichier4 } from './../../assets/img/avignon';


const Avignon = (): React.JSX.Element => {

    const { t } = useTranslation();

    return (
        <>
            <Section className="section-etude py-5">
                <Row>
                    <Col xs={12} lg={6} className="text-center">
                        <h4 dangerouslySetInnerHTML={{ __html: t('Pages.Avignon.Title')! }}></h4>
                    </Col>
                    <Col xs={12} lg={6}>
                        <div className="p-3">
                            <p className='case-study-desc'>{t('Pages.Avignon.SubTitle')} </p>
                        </div>
                    </Col>
                </Row>
            </Section>
            <div className='background-image avignon'></div>
            <Section className='case-study'>
                <Row className='justify-content-center'>
                    <Col xs={12} md={10}>
                        <div className='center-box'>
                        <h4 dangerouslySetInnerHTML={{ __html: t('Pages.Avignon.Title2')! }}></h4>
                            <p>{t('Pages.Avignon.Description')}</p>
                            <ArrowUpRight className='icon' size={48}/>
                        </div>
                    </Col>
                </Row>
                <Row className='text-center py-5'>
                    <p dangerouslySetInnerHTML={{ __html: t('Pages.Avignon.Quote')! }}></p>
                    <p className='text-start fw-bold' dangerouslySetInnerHTML={{ __html: t('Pages.Avignon.Author')! }}></p>
                </Row>
                <Row className='text-center py-3'>
                    <h4 dangerouslySetInnerHTML={{ __html: t('Pages.Avignon.Title3')! }}></h4>
                </Row>
                <Row className='justify-content-center text-center'>
                    <Col xs={12} md={6} lg={3}>
                        <div className='block'>
                            <img src={Fichier1} alt={t('Pages.Avignon.AltIconPassengers')} style={{ width: '120px' }} />
                            <p>{t('Pages.Avignon.Passengers')}</p>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={3}>
                        <div className='block'>
                            <img src={Fichier2} alt={t('Pages.Avignon.AltIconBus')} style={{ width: '120px' }} />
                            <p>{t('Pages.Avignon.Bus')}</p>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={3}>
                        <div className='block'>
                            <img src={Fichier3} alt={t('Pages.Avignon.AltIconClock')} style={{ width: '120px' }} />
                            <p>{t('Pages.Avignon.Clock')}</p>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={3}>
                        <div className='block'>
                            <img src={Fichier4} alt={t('Pages.Avignon.AltIconArrow')} style={{ width: '120px' }} />
                            <p>{t('Pages.Avignon.Arrow')}</p>
                        </div>
                    </Col>
                </Row>
            </Section>
        </>
    );
};

export default Avignon;